import { render, staticRenderFns } from "./niigmiinTvnshlel.vue?vue&type=template&id=034ed0df&"
import script from "./niigmiinTvnshlel.vue?vue&type=script&lang=js&"
export * from "./niigmiinTvnshlel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports